import { TemplateRef } from '@angular/core';

import { IIdentity, MorphingButtonConfig } from '.';

export interface AddConfig<T extends IIdentity> {
  disableAddShortcut?: boolean;
  allowAdding?: boolean;
  buttonTemplate?: TemplateRef<any>;
  buttonPosition?: 'header' | 'floating';
  value?: Partial<T> | (() => Partial<T>);
  keepAutogeneratedIds?: boolean;
  onAdded?: (...rows: T[]) => void;
  autoStartEdit?: boolean;
  /**
   * @description Morphing button works only with `buttonPosition: floating`
   */
  morphingButtonConfig?: MorphingButtonConfig;
  /**
   * @description when mode is set to dialog, the grid will open a dialog with the given component
   * > defaults to `inline`
   */
  mode?: 'inline' | 'dialog';
}
